<template>
    <div class="top-nav">
        <div class="top-nav-menu">
            <div
                    class="top-nav-menu_item"
                    v-for="item in menu"
            >
                <router-link :to="item.link">
                    {{ item.text }}
                </router-link>
            </div>
        </div>
        <div class="top-nav-search">
            <search-input></search-input>
        </div>
    </div>
</template>

<script>
    import SearchInput from '../Inputs/SearchInput';
    export default {
        name: "TopNav",
        components: { SearchInput },
        data() {
            return {
                menu: [
                    {
                        text: 'Лучшие товары',
                        link: 'best-products'
                    },
                    {
                        text: 'О нас',
                        link: 'about-us'
                    },
                    {
                        text: 'Гарантии и возврат',
                        link: 'warranties'
                    },
                    {
                        text: 'Доставка',
                        link: 'shipping'
                    },
                    {
                        text: 'Поддержка',
                        link: 'support'
                    },
                ]
            }
        }
    };
</script>

<style scoped lang="scss">
    .top-nav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        margin-left: 32px;
        &-menu {
            display: flex;
            justify-content: space-between;
            flex: 1;
            align-items: center;
            margin-right: 30px;
            &_item {
                padding: 0 10px;
                a {
                    font-size: 14px;
                    color: #3F4450;
                    cursor: pointer;
                    text-decoration: none;
                    position: relative;

                }
            }
        }
        &-search {
            background: #EEF2F6;
            border-radius: 5px;
            max-width: 280px;
            width: 100%;
        }
    }
</style>
